import { v4 as uuidv4 } from 'uuid';
import UTrackerImg from '../images/utracker.jpg';
import GreenCtgImg from '../images/greenctg.jpg';
import CoinTrackerImg from '../images/cointracker.jpg';
import img4 from '../images/img4.PNG';
import KeyCryptShieldImg from '../images/projects/keycrypt-shield.svg';
import SecuraMindImg from '../images/projects/securamind.svg';
import OfficersArenaImg from '../images/projects/officers-arena.svg';
import CdsQuizImg from '../images/projects/cds-quiz.svg';
import KeyCryptShieldXImg from '../images/projects/keycrypt-shield-x.svg';
import TasklyImg from '../images/projects/taskly.svg';
import OrbitImg from '../images/projects/orbit.svg';
import IotSafetyEngineImg from '../images/projects/iot-safety-engine.svg';
import PulseaiImg from '../images/projects/pulseai.svg';
import NeuroTideImg from '../images/projects/neurotide.svg';
import TechScopeAiImg from '../images/projects/techscope-ai.svg';
import CrashSentinelImg from '../images/projects/crashsentinel.svg';

const projects = [
  {
    id: uuidv4(),
    name: 'FortiCryptX',
    desc: 'A powerful and user-friendly cybersecurity tool for encrypting and decrypting files using industry-standard algorithms.',
    img: UTrackerImg,
    link: 'https://github.com/Brahamanbtp/FortiCryptX',
  },
  {
    id: uuidv4(),
    name: 'React Portfolio',
    desc: 'A sleek, responsive developer portfolio built using React to showcase projects, skills, and contact information.',
    img: GreenCtgImg,
    link: 'https://github.com/Brahamanbtp/react-portfolio',
  },
  {
    id: uuidv4(),
    name: 'Student Management System',
    desc: 'A role-based student management system to manage admissions, exams, library, hostel, and more with modern UI features.',
    img: CoinTrackerImg,
    link: 'https://github.com/Brahamanbtp/Student-Management-System',
  },
  {
    id: uuidv4(),
    name: 'KeyCrypt Shield',
    desc: 'An advanced encryption and password manager app designed to securely store and manage sensitive user credentials.',
    img: KeyCryptShieldImg,
    link: 'https://github.com/Brahamanbtp/KeyCrypt-Shield',
  },
  {
    id: uuidv4(),
    name: 'SecuraMind',
    desc: 'AI-powered secure code assistant that detects and fixes vulnerabilities using LLMs like Mistral, deployed with Gradio + Modal.',
    img: SecuraMindImg,
    link: 'https://github.com/Brahamanbtp/SecuraMind',
  },
  {
    id: uuidv4(),
    name: 'DevQR Card',
    desc: 'DevQRCard is a beautifully designed platform for developers to create, customize, and share their digital identity cards with integrated QR codes, profiles, and portfolios.',
    img: img4,
    link: 'https://github.com/Brahamanbtp/devqr-card',
  },
  {
    id: uuidv4(),
    name: 'Officers Arena',
    desc: 'A research-backed adaptive examination platform for UPSC, CDS, NDA, and AFCAT preparation with AI tutoring, mock exams, and performance analytics.',
    img: OfficersArenaImg,
    link: 'https://github.com/Brahamanbtp/Officers_Arena',
  },
  {
    id: uuidv4(),
    name: 'CDS Quiz',
    desc: 'A responsive quiz application for Combined Defence Services exam preparation with subject-wise question banks for English, General Knowledge, and Mathematics.',
    img: CdsQuizImg,
    link: 'https://github.com/Brahamanbtp/cds-quiz',
  },
  {
    id: uuidv4(),
    name: 'KeyCrypt Shield X',
    desc: 'A provider-driven cryptography platform with a Python SDK, CLI, policy-aware workflows, key management, and pluggable storage integrations.',
    img: KeyCryptShieldXImg,
    link: 'https://github.com/Brahamanbtp/KeyCrypt-Shield-X',
  },
  {
    id: uuidv4(),
    name: 'Taskly',
    desc: 'An enterprise Kanban platform with real-time collaboration, role-based access control, analytics, AI-powered search, and automated audit logging.',
    img: TasklyImg,
    link: 'https://github.com/Brahamanbtp/taskly',
  },
  {
    id: uuidv4(),
    name: 'ORBIT',
    desc: 'A block-level adaptive compression framework that uses a LinUCB contextual bandit to route data to the most suitable codec.',
    img: OrbitImg,
    link: 'https://github.com/Brahamanbtp/ORBIT',
  },
  {
    id: uuidv4(),
    name: 'IoT Safety Engine',
    desc: 'An ESP32 smart monitoring system using RFID, gas, temperature, current, vibration, and distance sensors to detect risks and trigger safety responses.',
    img: IotSafetyEngineImg,
    link: 'https://github.com/Brahamanbtp/IoT-Safety-Engine',
  },
  {
    id: uuidv4(),
    name: 'PulseAI',
    desc: 'An AI hardware profiler that measures workload performance, system telemetry, stability, and energy efficiency to recommend the best compute backend.',
    img: PulseaiImg,
    link: 'https://github.com/Brahamanbtp/Pulseai',
  },
  {
    id: uuidv4(),
    name: 'NeuroTide',
    desc: 'An asynchronous AI-assisted torrent engine with predictive streaming, adaptive piece prioritization, privacy-first delivery, and multi-device continuity.',
    img: NeuroTideImg,
    link: 'https://github.com/Brahamanbtp/NeuroTide',
  },
  {
    id: uuidv4(),
    name: 'TechScope AI',
    desc: 'An AI-powered technology news dashboard that summarizes articles, scores credibility, extracts keywords, and stores results through a FastAPI and Streamlit stack.',
    img: TechScopeAiImg,
    link: 'https://github.com/Brahamanbtp/TechScope-AI',
  },
  {
    id: uuidv4(),
    name: 'CrashSentinel',
    desc: 'An AI-powered early warning system for market instability using financial, housing, credit, and sentiment signals with anomaly detection and risk scoring.',
    img: CrashSentinelImg,
    link: 'https://github.com/Brahamanbtp/CrashSentinel',
  },
];

export default projects;
